import SecretIDIcon from './component'

export default SecretIDIcon
